var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcnArrow = function SvgIcnArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111928",
    d: "M9.013 12.5c-.279 0-.546-.105-.742-.292l-4.2-3.992a1 1 0 0 1-.236-.324.96.96 0 0 1 .223-1.1q.149-.141.344-.218a1.1 1.1 0 0 1 1.153.23l3.458 3.287 3.458-3.286a1.08 1.08 0 0 1 .738-.28c.275.002.539.107.734.292a.97.97 0 0 1 .307.697.97.97 0 0 1-.295.702l-4.2 3.992a1.08 1.08 0 0 1-.742.292"
  })));
};
export default SvgIcnArrow;